<template>
  <div class="text-white">
    <div class="max-w-5xl mx-auto px-6 py-10">
      <!-- Cabeçalho -->
      <div class="mb-8">
        <h1 class="text-3xl font-bold mb-3">Configure o Split de Comissões</h1>
        <p class="text-[#9CA3AF] leading-relaxed text-sm">
          Defina como as comissões serão distribuídas entre organizações parceiras. Para cada venda realizada, 
          você pode configurar valores fixos e/ou percentuais que serão automaticamente repassados.
          Configure múltiplos splits para diferentes organizações e acompanhe tudo em tempo real.
        </p>
      </div>

      <!-- Cards de Resumo -->
      <!-- <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        <div class="bg-white/5 rounded-xl p-5 backdrop-blur-sm">
          <div class="flex items-center mb-2">
            <Building2 class="h-5 w-5 text-emerald-400 mr-2" />
            <h3 class="text-sm font-medium text-[#9CA3AF]">Organizações Parceiras</h3>
          </div>
          <p class="text-2xl font-bold">{{ paymentSplits?.data.length }}</p>
        </div>
        
        <div class="bg-white/5 rounded-xl p-5 backdrop-blur-sm">
          <div class="flex items-center mb-2">
            <Percent class="h-5 w-5 text-emerald-400 mr-2" />
            <h3 class="text-sm font-medium text-[#9CA3AF]">Percentual Total</h3>
          </div>
          <div class="flex items-center">
            <p class="text-2xl font-bold" v-if="totalPercentual">{{ totalPercentual }}%</p>
            <span 
              class="ml-2 text-xs px-2 py-0.5 rounded-full"
              :class="totalPercentual <= 100 ? 'bg-emerald-500/20 text-emerald-400' : 'bg-red-500/20 text-red-400'"
            >
              {{ totalPercentual <= 100 ? 'Válido' : 'Excedido' }}
            </span>
          </div>
        </div>
        
        <div class="bg-white/5 rounded-xl p-5 backdrop-blur-sm">
          <div class="flex items-center mb-2">
            <DollarSign class="h-5 w-5 text-emerald-400 mr-2" />
            <h3 class="text-sm font-medium text-[#9CA3AF]">Valor Fixo Total</h3>
          </div>
          <p class="text-2xl font-bold" v-if="totalValorFixo">{{ formatarMoeda(totalValorFixo) }}</p>
        </div>
      </div> -->

      <!-- Formulário de Adição -->
      <div class="bg-white/5 rounded-xl p-6 mb-10 backdrop-blur-sm">
        <h2 class="text-xl font-bold mb-4">Adicionar Nova Organização</h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block text-sm font-medium text-[#9CA3AF] mb-2">Organização Receptora</label>
            <div class="relative">
              <!-- Select do shadcn -->
              <Select v-model="paymentSplitForm.commissionRecipientOrganizationId" multiple>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione a categoria" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem
                    v-for="org in selectableOrganizations" 
                    :key="org.id" 
                    :value="String(org.id)"
                  >
                    {{ org.name }}
                  </SelectItem>
                  <div 
                    v-if="!organizations" 
                    class="flex items-center justify-center p-4"
                  >
                    <Loader2 class="w-5 h-5 animate-spin" />
                  </div>
                  <div class="text-sm p-4 flex justify-center items-center" v-if="organizations && !selectableOrganizations.length">
                    <Search class="w-5 h-5 text-[#9CA3AF] mr-2" />
                    Nenhuma organização encontrada
                  </div>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-[#9CA3AF] mb-2">Percentual (%)</label>
              <div class="relative">
                <Input
                  v-model="paymentSplitForm.percentage" 
                  type="number" 
                  min="0" 
                  max="100" 
                  class="w-full  border-0 text-white rounded-lg p-3 focus:ring-1 focus:ring-emerald-500"
                  placeholder="0.00"
                />
                <Percent class="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#9CA3AF]" />
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-[#9CA3AF] mb-2">Valor Fixo (R$)</label>
              <div class="relative">
                <Input
                  v-model="paymentSplitForm.amount" 
                  type="number" 
                  min="0" 
                  step="0.01" 
                  class="w-full  border-0 text-white rounded-lg p-3 focus:ring-1 focus:ring-emerald-500"
                  placeholder="0.00"
                />
                <DollarSign class="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#9CA3AF]" />
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white/5 rounded-lg p-3">
            <div class="flex justify-between items-center mb-1">
              <span class="text-xs text-[#9CA3AF]">Percentual Total: {{ totalPercentual || 0 }}% / 30%</span>
              <span class="text-xs" :class="(totalPercentual || 0) > 30 ? 'text-red-400' : 'text-emerald-400'">
                {{ Math.min(Math.round(((totalPercentual || 0) / 30) * 100), 100) }}%
              </span>
            </div>
            <div class="w-full bg-white/10 rounded-full h-2">
              <div 
                class="h-2 rounded-full transition-all duration-300" 
                :class="(totalPercentual || 0) > 30 ? 'bg-red-400' : 'bg-emerald-400'"
                :style="`width: ${Math.min(((totalPercentual || 0) / 30) * 100, 100)}%`"
              ></div>
            </div>
          </div>
          
          <div class="bg-white/5 rounded-lg p-3">
            <div class="flex justify-between items-center mb-1">
              <span class="text-xs text-[#9CA3AF]">Valor Fixo Total: {{ (totalValorFixo || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }} / R$ 1,00</span>
              <span class="text-xs" :class="(totalValorFixo || 0) > 1 ? 'text-red-400' : 'text-emerald-400'">
                {{ Math.min(Math.round(((totalValorFixo || 0) / 1) * 100), 100) }}%
              </span>
            </div>
            <div class="w-full bg-white/10 rounded-full h-2">
              <div 
                class="h-2 rounded-full transition-all duration-300" 
                :class="(totalValorFixo || 0) > 1 ? 'bg-red-400' : 'bg-emerald-400'"
                :style="`width: ${Math.min(((totalValorFixo || 0) / 1) * 100, 100)}%`"
              ></div>
            </div>
          </div>
        </div>

        <!-- <div class="mt-6">
          <label class="block text-sm font-medium text-[#9CA3AF] mb-2">Descrição (opcional)</label>
          <Textarea
            v-model="paymentSplitForm.descricao" 
            class="w-full  border-0 text-white rounded-lg p-3 focus:ring-1 focus:ring-emerald-500 min-h-[80px]"
            placeholder="Descreva o propósito deste split..."
          ></Textarea>
        </div> -->
        
        <div class="mt-4">
          <div v-if="limitsExceeded.any" class="bg-amber-500/20 border border-amber-500/30 rounded-lg p-4 mb-4 animate-pulse">
            <div class="flex items-start">
              <AlertTriangle class="h-5 w-5 text-amber-400 mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h4 class="font-medium text-amber-400">Limite de Split Excedido</h4>
                <p class="text-[#9CA3AF] text-sm mt-1">
                  <span v-if="limitsExceeded.percent" class="block">• O total de percentual não pode exceder 30% (atual: {{ totalPercentual }}% + novo: {{ paymentSplitForm.percentage || 0 }}%)</span>
                  <span v-if="limitsExceeded.fixed" class="block">• O valor fixo total não pode exceder R$ 1,00 (atual: {{ (totalValorFixo || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }} + novo: {{ (paymentSplitForm.amount ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }})</span>
                  <span class="block mt-1 text-amber-400">Ajuste os valores para continuar.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="flex justify-end mt-6">
          <button 
            @click="handlePaymentSplitCreate" 
            class="bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-2.5 rounded-lg font-medium transition-colors flex items-center"
            :disabled="!paymentSplitFormValida || isCreatingPaymentSplit || limitsExceeded.any"
            :class="{'opacity-50 cursor-not-allowed': !paymentSplitFormValida || isCreatingPaymentSplit || limitsExceeded.any}"
          >
            <Loader2 v-if="isCreatingPaymentSplit" class="w-5 h-5 mr-2 animate-spin" />
            <PlusCircle v-else class="h-5 w-5 mr-2" />
            Adicionar Organização
          </button>
        </div>
      </div>

      <!-- Lista de Organizações -->
      <div class="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 class="text-xl font-bold">Splits Configurados</h2>
          <p class="text-[#9CA3AF] text-sm mt-1">Gerencie as organizações que receberão comissões</p>
        </div>
      </div>

      <!-- Tabela usando os componentes fornecidos -->
      <div class="bg-white/5 rounded-xl overflow-hidden backdrop-blur-sm">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead v-for="header in tableHeaders" :key="header.key" :class="header.class">
                <div class="flex items-center gap-2">
                  {{ header.label }}
                  <ArrowsUpDown 
                    v-if="header.sortable"
                    class="h-4 w-4 cursor-pointer text-gray-500 hover:text-white"
                    @click="sortBy(header.key)"
                  />
                </div>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <template v-if="paymentSplits">
              <TableFallback 
                v-if="paymentSplits?.data.length === 0" 
                :colspan="tableHeaders.length" 
                :icon="Split" 
                title="Nenhuma organização configurada" 
                description="Adicione uma organização para começar a configurar os splits" 
              />
              <TableRow v-for="(split, index) in paymentSplits?.data" :key="index">
                <TableCell>
                  <div class="flex items-center">
                    <div class="h-8 w-8 rounded-full bg-emerald-500/20 flex items-center justify-center mr-3">
                      <Building2 class="h-4 w-4 text-emerald-400" />
                    </div>
                    <div class="text-sm font-medium text-white">{{ getOrganizationName(split.organizationId) }}</div>
                  </div>
                </TableCell>
                <TableCell>
                  <span class="bg-emerald-500/20 text-emerald-400 px-2 py-0.5 rounded-full text-sm">
                    {{ split.percentage }}%
                  </span>
                </TableCell>
                <TableCell>
                  <div class="text-sm font-medium text-white">{{ split.amount?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</div>
                </TableCell>
                <!-- <TableCell>
                  <div class="text-sm text-[#9CA3AF] max-w-[200px] truncate">{{ org.description || '-' }}</div>
                </TableCell> -->
                <TableCell>
                  <div class="flex gap-2">
                    <!-- <button 
                      @click="editarOrganizacao(index)" 
                      class="p-2 rounded-md hover:bg-white/10 text-[#9CA3AF] hover:text-white transition-colors"
                    >
                      <Edit2 class="h-4 w-4" />
                    </button> -->
                    <button 
                      @click="handleDeletePaymentSplit(split)" 
                      class="p-2 rounded-md hover:bg-white/10 text-[#9CA3AF] hover:text-white transition-colors"
                    >
                      <Trash2 class="h-4 w-4" />
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            </template>
            <TableRowSkeleton :columns="tableHeaders.length" v-else />
          </TableBody>
        </Table>
      </div>

      <!-- Informações sobre comissões -->
      <div class="mt-10 bg-white/5 rounded-xl p-6 backdrop-blur-sm">
        <div class="flex flex-col md:flex-row items-start gap-6">
          <div class="rounded-full bg-emerald-500/20 p-4 shrink-0">
            <InfoIcon class="h-6 w-6 text-emerald-400" />
          </div>
          
          <div class="flex-1">
            <h3 class="text-lg font-bold mb-1">Como funcionam as comissões</h3>
            <p class="text-[#9CA3AF] text-sm leading-relaxed">
              Para cada venda realizada, o sistema irá automaticamente distribuir as comissões conforme configurado acima.
              Você pode definir um percentual sobre o valor da venda e/ou um valor fixo para cada organização parceira.
              <span class="text-emerald-400">O split é processado em tempo real</span> e os valores são depositados diretamente
              nas contas das organizações receptoras.
            </p>
            
            <div class="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="bg-white/5 p-5 rounded-lg">
                <h4 class="font-medium mb-3 flex items-center text-emerald-400">
                  <Calculator class="h-5 w-5 mr-2" />
                  Exemplo de cálculo
                </h4>
                <p class="text-[#9CA3AF] text-sm">
                  Para uma venda de <span class="text-white font-medium">R$ 100,00</span>:
                </p>
                <ul class="mt-3 space-y-2 text-sm text-[#9CA3AF]">
                  <li class="flex justify-between items-center bg-white/5 p-2 rounded">
                    <span class="flex items-center">
                      <div class="h-6 w-6 rounded-full bg-emerald-500/20 flex items-center justify-center mr-2">
                        <Building2 class="h-3 w-3 text-emerald-400" />
                      </div>
                      Organização A (10% + R$ 5,00 fixo):
                    </span>
                    <span class="text-white font-medium">R$ 15,00</span>
                  </li>
                  <li class="flex justify-between items-center bg-white/5 p-2 rounded">
                    <span class="flex items-center">
                      <div class="h-6 w-6 rounded-full bg-emerald-500/20 flex items-center justify-center mr-2">
                        <Building2 class="h-3 w-3 text-emerald-400" />
                      </div>
                      Organização B (5% + R$ 0,00 fixo):
                    </span>
                    <span class="text-white font-medium">R$ 5,00</span>
                  </li>
                  <li class="flex justify-between mt-3 pt-3 border-t border-white/10 font-medium">
                    <span>Total repassado:</span>
                    <span class="text-emerald-400">R$ 20,00</span>
                  </li>
                </ul>
              </div>
              
              <div class="bg-white/5 p-5 rounded-lg">
                <h4 class="font-medium mb-3 flex items-center text-amber-400">
                  <AlertTriangle class="h-5 w-5 mr-2" />
                  Limites e Recomendações
                </h4>
                <ul class="space-y-3 text-sm">
                  <li class="flex items-start gap-3 bg-white/5 p-3 rounded">
                    <div class="h-6 w-6 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0 mt-0.5">
                      <Percent class="h-3 w-3 text-amber-400" />
                    </div>
                    <div>
                      <span class="text-white font-medium">Limite de Percentual: 30%</span>
                      <p class="text-[#9CA3AF] mt-1">Mantenha o percentual total abaixo de 30% para garantir margem de lucro adequada.</p>
                    </div>
                  </li>
                  <li class="flex items-start gap-3 bg-white/5 p-3 rounded">
                    <div class="h-6 w-6 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0 mt-0.5">
                      <DollarSign class="h-3 w-3 text-amber-400" />
                    </div>
                    <div>
                      <span class="text-white font-medium">Limite de Valor Fixo: R$ 1,00</span>
                      <p class="text-[#9CA3AF] mt-1">Configure valores fixos com cautela para evitar prejuízos em vendas de baixo valor.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationDialog v-model:open="isDeletePaymentSplitDialogOpen" :loading="isDeletingPaymentSplit" @confirm="isDeletingPaymentSplit = true; destroyPaymentSplit(deletingPaymentSplit!.id).then(() => {
        toast({
          title: 'Split excluído com sucesso',
          class: 'bg-green-500 text-white',
          duration: 1500
        })
        isDeletingPaymentSplit = false
        isDeletePaymentSplitDialogOpen = false
        const index = paymentSplits?.data.findIndex(split => split.id == deletingPaymentSplit?.id)
        if (index !== -1) paymentSplits?.data.splice(index!, 1)
      })" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onUnmounted, onMounted } from 'vue'
import { 
  Building2, 
  Percent, 
  DollarSign, 
  ChevronDown, 
  PlusCircle, 
  Search, 
  Edit2, 
  Trash2, 
  AlertCircle,
  Info as InfoIcon,
  Calculator,
  Check,
  AlertTriangle,
  Split,
  Loader2
} from 'lucide-vue-next'

// Importação dos componentes de tabela
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import { CreatePaymentSplitDTO, usePaymentSplit } from '@/composables/usePaymentSplit'
import { useOrganization } from '@/composables/useOrganization'
import { Organization } from '@/interfaces/organizations/Organization'
import { PaymentSplit } from '@/interfaces/payment-splits/PaymentSplit'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { toast } from '@/components/ui/toast'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'

interface TableHeader {
  key: string
  label: string
  sortable?: boolean
  class?: string
}

const organizations = ref<Organization[]>()
const paymentSplits = ref<IPagination<PaymentSplit>>()
  
const { getAll: getAllPaymentSplits, create: createPaymentSplit, destroy: destroyPaymentSplit } = usePaymentSplit()
const { getAll: getAllOrganizations, organization } = useOrganization()
const selectableOrganizations = computed(() => organizations.value?.filter(org => !paymentSplits.value?.data.some(split => split.commissionRecipientOrganizationId === org.id) && org.id != organization.id) || [])
const isCreatingPaymentSplit = ref(false)
const isDeletingPaymentSplit = ref(false)
const isDeletePaymentSplitDialogOpen = ref(false)
const deletingPaymentSplit = ref<PaymentSplit | null>(null)

const handlePaymentSplitCreate = async () => {
  isCreatingPaymentSplit.value = true
  await createPaymentSplit(paymentSplitForm.value as CreatePaymentSplitDTO)
  paymentSplitForm.value = {}
  isCreatingPaymentSplit.value = false
  paymentSplits.value = await getAllPaymentSplits()
}

// Configuração dos cabeçalhos da tabela
const tableHeaders = ref<TableHeader[]>([
  { key: 'organizacao', label: 'ORGANIZAÇÃO', sortable: true },
  { key: 'percentual', label: 'PERCENTUAL', sortable: true },
  { key: 'valorFixo', label: 'VALOR FIXO', sortable: true },
  // { key: 'descricao', label: 'DESCRIÇÃO' },
  { key: 'acoes', label: 'AÇÕES', class: 'text-right' }
])

// Estado para nova organização
const paymentSplitForm = ref<Partial<CreatePaymentSplitDTO>>({})

// Estado para ordenação
const sortConfig = ref({
  key: '',
  direction: 'asc'
})

// Validação da nova organização
const paymentSplitFormValida = computed(() => {
  return paymentSplitForm.value.commissionRecipientOrganizationId && 
         ((paymentSplitForm.value.percentage ?? 0) > 0 || (paymentSplitForm.value.amount ?? 0) > 0)
})

// Cálculo do total de percentual
const totalPercentual = computed(() => {
  return paymentSplits.value?.data.reduce((total, org) => total + org.percentage, 0)
})

// Cálculo do total de valor fixo
const totalValorFixo = computed(() => {
  return paymentSplits.value?.data.reduce((total, org) => total + org.amount, 0)
})

// Verificação se os limites foram excedidos
const limitsExceeded = computed(() => {
  const currentPercentTotal = totalPercentual.value || 0;
  const currentFixedTotal = totalValorFixo.value || 0;
  
  // Verifica se adicionando o novo percentual excederia 30%
  const newPercentTotal = currentPercentTotal + (paymentSplitForm.value.percentage || 0);
  
  // Verifica se adicionando o novo valor fixo excederia 1 BRL
  const newFixedTotal = currentFixedTotal + (paymentSplitForm.value.amount || 0);
  
  return {
    percent: newPercentTotal > 30,
    fixed: newFixedTotal > 1,
    any: newPercentTotal > 30 || newFixedTotal > 1
  };
});

function handleDeletePaymentSplit(paymentSplit: PaymentSplit) {
  deletingPaymentSplit.value = paymentSplit
  isDeletePaymentSplitDialogOpen.value = true
}

function sortBy(key: string) {
  if (sortConfig.value.key === key) {
    // Inverter direção se já estiver ordenando por esta coluna
    sortConfig.value.direction = sortConfig.value.direction === 'asc' ? 'desc' : 'asc'
  } else {
    // Nova coluna para ordenação
    sortConfig.value.key = key
    sortConfig.value.direction = 'asc'
  }
}

const getOrganizationName = (id: number) => {
  const org = organizations.value?.find(o => o.id === id)
  return org ? org.name : 'Organização Desconhecida'
}

onMounted(async () => {
  getAllOrganizations()
    .then((data) => {
      organizations.value = data
    })
  getAllPaymentSplits()
    .then((data) => {
      paymentSplits.value = data
    })
})
</script>

<style>
/* Transições suaves para elementos interativos */
/* .transition-colors {
  transition: all 0.2s ease;
} */

/* Efeito de vidro fosco */
/*.backdrop-blur-sm {
  backdrop-filter: blur(4px);
}*/

/* Animação para elementos */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* tr, .bg-gradient-to-br {
  animation: fadeIn 0.3s ease;
} */

/* Estilização de inputs */
/* input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
} */
</style>

